import { useMutation } from '@tanstack/react-query';
import { useApi } from '../../lib/api';

export interface AcceptInvitationPayload {
  token: string;
  password?: string;
}

export interface AcceptInvitationResult {
  user_id?: string;
  message?: string;
}

interface ErrorBody {
  error?: string;
  message?: string;
}

export interface AcceptInvitationError extends Error {
  status?: number;
  body?: ErrorBody;
}

export function useAcceptInvitation() {
  const api = useApi();
  return useMutation<AcceptInvitationResult, AcceptInvitationError, AcceptInvitationPayload>({
    mutationFn: async ({ token, password }) => {
      const body: AcceptInvitationPayload = password ? { token, password } : { token };
      const { data, error, response } = (await api.POST('/auth/accept-invite' as never, {
        body,
        // Accept: */* selects the cookie branch on the backend so the SPA is
        // auto-logged-in by the response Set-Cookie headers.
        headers: { Accept: '*/*' },
      } as never)) as { data?: unknown; error?: unknown; response: Response };
      if (error) {
        const err = new Error('accept_invitation_failed') as AcceptInvitationError;
        err.status = response?.status;
        err.body = error as ErrorBody;
        throw err;
      }
      return (data ?? {}) as AcceptInvitationResult;
    },
  });
}
